var _path, _path2, _g, _g2, _path3, _g3, _path4, _path5, _path6, _path7, _path8, _g4, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFifty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 52,
    viewBox: "0 0 49 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 21.6064L29.2735 25.9912L18.7736 52L14.0281 46.9806L7 47.6153L17.4999 21.6064Z",
    fill: "#BB3027"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1385 21L18.3649 25.3847L28.8648 51.3936L33.6103 46.3742L40.6384 47.0088L30.1385 21Z",
    fill: "#BB3027"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0L27.3221 2.6821L30.8348 1.00334L32.69 4.42624L36.5496 3.91515L37.2562 7.74379L41.0848 8.4504L40.5738 12.31L43.9967 14.1652L42.3179 17.6779L45 20.5L42.3179 23.3221L43.9967 26.8348L40.5738 28.69L41.0848 32.5496L37.2562 33.2562L36.5496 37.0848L32.69 36.5738L30.8348 39.9967L27.3221 38.3179L24.5 41L21.6779 38.3179L18.1652 39.9967L16.31 36.5738L12.4504 37.0848L11.7438 33.2562L7.9152 32.5496L8.4262 28.69L5.0033 26.8348L6.6821 23.3221L4 20.5L6.6821 17.6779L5.0033 14.1652L8.4262 12.31L7.9152 8.4504L11.7438 7.74379L12.4504 3.91515L16.31 4.42624L18.1652 1.00334L21.6779 2.6821L24.5 0Z",
    fill: "#A8A9A8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 20.5C41 29.6127 33.6127 37 24.5 37C15.3873 37 8 29.6127 8 20.5C8 11.3873 15.3873 4 24.5 4C33.6127 4 41 11.3873 41 20.5Z",
    fill: "#A8A9A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 20.5C39 28.5081 32.5081 35 24.5 35C16.4919 35 10 28.5081 10 20.5C10 12.4919 16.4919 6 24.5 6C32.5081 6 39 12.4919 39 20.5Z",
    stroke: "#C0C0C0",
    strokeWidth: 4
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 20.5C35 26.299 30.299 31 24.5 31C18.701 31 14 26.299 14 20.5C14 14.701 18.701 10 24.5 10C30.299 10 35 14.701 35 20.5Z",
    fill: "#CECECE"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1_111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.25 25.1953C18.8698 25.1953 19.4349 25.0599 19.9453 24.7891C20.4609 24.5182 20.8646 24.1589 21.1562 23.7109C21.4531 23.2578 21.6016 22.7786 21.6016 22.2734C21.6016 21.7109 21.4583 21.2005 21.1719 20.7422C20.8906 20.2839 20.4609 19.9062 19.8828 19.6094C19.3047 19.3125 18.5938 19.125 17.75 19.0469L18.0312 17.1875L21.0547 17.0625L21.2578 15.6406L17.5938 15.8672L16.6641 20.2969C17.4297 20.349 18.0781 20.487 18.6094 20.7109C19.1458 20.9297 19.5495 21.2161 19.8203 21.5703C20.0911 21.9245 20.2266 22.3255 20.2266 22.7734C20.2266 23.112 20.1589 23.4115 20.0234 23.6719C19.888 23.9271 19.6979 24.125 19.4531 24.2656C19.2083 24.4062 18.9219 24.4766 18.5938 24.4766C18.2448 24.4766 17.9349 24.4219 17.6641 24.3125C17.3932 24.1979 17.1797 24.0234 17.0234 23.7891L16.9375 22.125L16.2734 21.9766L15.9922 24.4219C16.2786 24.7083 16.6068 24.9089 16.9766 25.0234C17.3464 25.138 17.7708 25.1953 18.25 25.1953ZM26.5312 25.2109C27.099 25.2109 27.625 25.0625 28.1094 24.7656C28.5938 24.4635 28.9896 23.9557 29.2969 23.2422C29.6094 22.5286 29.7656 21.5885 29.7656 20.4219C29.7656 19.3229 29.6328 18.4141 29.3672 17.6953C29.1016 16.9766 28.7318 16.4479 28.2578 16.1094C27.7839 15.7708 27.224 15.6016 26.5781 15.6016C25.974 15.6016 25.4193 15.776 24.9141 16.125C24.4141 16.4688 24.0104 17.0026 23.7031 17.7266C23.401 18.4505 23.25 19.349 23.25 20.4219C23.25 22.1979 23.5469 23.4401 24.1406 24.1484C24.7344 24.8568 25.5312 25.2109 26.5312 25.2109ZM26.5156 16.4219C26.9219 16.4219 27.237 16.5677 27.4609 16.8594C27.6849 17.1458 27.8411 17.5755 27.9297 18.1484C28.0182 18.7214 28.0625 19.4792 28.0625 20.4219C28.0625 21.3698 28.0156 22.1354 27.9219 22.7188C27.8333 23.3021 27.6823 23.737 27.4688 24.0234C27.2552 24.3099 26.9583 24.4531 26.5781 24.4531C26.1406 24.4531 25.8021 24.3099 25.5625 24.0234C25.3281 23.737 25.1641 23.3099 25.0703 22.7422C24.9818 22.1693 24.9375 21.4036 24.9375 20.4453C24.9375 19.5026 24.9818 18.7422 25.0703 18.1641C25.1641 17.5859 25.3255 17.151 25.5547 16.8594C25.7839 16.5677 26.1042 16.4219 26.5156 16.4219ZM32.4609 21.8047V23.5547L33.3359 23.6406L33.3203 21.8047H34.9453L35.0391 21.0156H33.3203L33.3125 19.3047L32.4609 19.2109V21.0156H30.8281L30.7344 21.8047H32.4609Z",
    fill: "#7D7D7D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_111",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 0,
    width: 41,
    height: 52
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4999 21.6064L29.2735 25.9912L18.7736 52L14.0281 46.9806L7 47.6153L17.4999 21.6064Z",
    fill: "#BB3027"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1385 21L18.3649 25.3847L28.8648 51.3936L33.6103 46.3742L40.6384 47.0088L30.1385 21Z",
    fill: "#BB3027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0L27.3221 2.6821L30.8348 1.00334L32.69 4.42624L36.5496 3.91515L37.2562 7.74379L41.0848 8.4504L40.5738 12.31L43.9967 14.1652L42.3179 17.6779L45 20.5L42.3179 23.3221L43.9967 26.8348L40.5738 28.69L41.0848 32.5496L37.2562 33.2562L36.5496 37.0848L32.69 36.5738L30.8348 39.9967L27.3221 38.3179L24.5 41L21.6779 38.3179L18.1652 39.9967L16.31 36.5738L12.4504 37.0848L11.7438 33.2562L7.9152 32.5496L8.4262 28.69L5.0033 26.8348L6.6821 23.3221L4 20.5L6.6821 17.6779L5.0033 14.1652L8.4262 12.31L7.9152 8.4504L11.7438 7.74379L12.4504 3.91515L16.31 4.42624L18.1652 1.00334L21.6779 2.6821L24.5 0Z",
    fill: "#352929"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39 20.5C39 28.5081 32.5081 35 24.5 35C16.4919 35 10 28.5081 10 20.5C10 12.4919 16.4919 6 24.5 6C32.5081 6 39 12.4919 39 20.5Z",
    fill: "#372F2A",
    stroke: "#403831",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35 20.5C35 26.299 30.299 31 24.5 31C18.701 31 14 26.299 14 20.5C14 14.701 18.701 10 24.5 10C30.299 10 35 14.701 35 20.5Z",
    fill: "#544E48"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9174 -6L46 16.5L4.5 30L-1.5 6.17949L34.9174 -6Z",
    fill: "#544E48"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8L15.1752 9.8248L17 10.5L15.1752 11.1752L14.5 13L13.8248 11.1752L12 10.5L13.8248 9.8248L14.5 8Z",
    fill: "white",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_111",
    x: 0,
    y: 0,
    width: 49,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_111"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_111",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_111",
    x: 4,
    y: 4,
    width: 41,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_111"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_111",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1_111",
    x: 11.9922,
    y: 15.6016,
    width: 27.0469,
    height: 17.6093,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_111"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_111",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFifty);
export default __webpack_public_path__ + "static/media/fifty.3992cef1582581cf4261606e52841bb0.svg";
export { ForwardRef as ReactComponent };